<template>
	<div id="">
		<!-- <div ref="scrollHome" style="position: fixed;top:0; width: 100%;z-index: 999;"> -->
		<div ref="scrollHome">
			<HeaderNav :navIndex='navIndex' @click='hSwitchNav' />
		</div>

		<Home />
		<div ref="scrollAbout">
			<About :windowWidth='windowWidth' style='margin-top: -1px;' />
		</div>
		<div ref="scrollProject">
			<Project style='margin-top: -1px;' />
		</div>
		<div ref="scrollContact">
			<Contact style='margin-top: -1px;' />
		</div>
		<div ref="scrollFooter">
			<Footer style='margin-top: -1px;' :isFixed="isFixed" @click='hSwitchNav' />
		</div>

	</div>
</template>

<script>
import { getSetGray } from '@/utils/api.js'
import HeaderNav from '@/components/HeaderNav.vue'
import Home from '@/components/Home.vue'
import About from '@/components/About.vue'
import Project from '@/components/Project.vue'
import Contact from '@/components/Contact.vue'
import Footer from '@/components/Footer.vue'

export default {
	name: 'index',
	components: {
		HeaderNav,
		Home,
		About,
		Project,
		Contact,
		Footer
	},
	data() {
		return {
			homeTop: null,
			aboutTop: null,
			projectTop: null,
			contactTop: null,
			footerTop: null,

			windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
			windowHeight: document.documentElement.clientHeight,
			isFixed: false,

			navIndex: 0,

		}
	},
	created() {
		document.title = this.$t('nav.home')
		// console.log("windowWidth: ",this.windowWidth);
		this.getSetGray()

	},
	mounted() {

		window.addEventListener('scroll', this.handleScrollx, true)
		var that = this;
		// 把window.onresize事件挂在到mounted函数上
		window.onresize = () => {
			return (() => {
				window.fullHeight = document.documentElement.clientHeight;
				window.fullWidth = document.documentElement.clientWidth;
				that.windowHeight = window.fullHeight; // 高
				that.windowWidth = window.fullWidth; // 宽
				// console.log("that.windowWidth: ",that.windowWidth);

				// 是否固定底部 
				if (this.windowWidth < 480) {
					if (this.footerTop < 630) {
						this.isFixed = false
					} else {
						this.isFixed = true
					}
				} else {
					this.isFixed = false
				}
			})()
		};
	},
	methods: {
		// 首页置灰
		async getSetGray() {
			const res = await getSetGray()
			if (res.code == 200) {
				let date = {
					isDuringDate(beginDateStr, endDateStr) {
						let curDate = new Date(),
							beginDate = new Date(beginDateStr),
							endDate = new Date(endDateStr);
						if (curDate >= beginDate && curDate <= endDate) {
							return true;
						}
						return false;
					}
				}

				if (date.isDuringDate(res.content.start, res.content.end) == true && res.content.type == 1) {
					document.documentElement.style.filter = 'grayscale(100%)'
				} else {
					document.documentElement.style.filter = 'none'
				}
			}
		},
		hSwitchNav(e) {
			this.navIndex = e
			// 切换到指定位置
			switch (e) {
				case 0:
					this.$refs.scrollHome.scrollIntoView(true)
					document.body.scrollTop = 0;
					document.documentElement.scrollTop = 0;
					break;
				case 1:
					this.$refs.scrollAbout.scrollIntoView(true)
					this.navIndex = 1
					break;
				case 2:
					this.$refs.scrollProject.scrollIntoView(true)
					this.navIndex = 2
					break;
				case 3:
					this.$refs.scrollContact.scrollIntoView(true)
					this.navIndex = 3
					break;
				default:
					break;
			}

		},
		handleScrollx() {
			// 滚动到指定位置 高亮显示
			this.homeTop = this.$refs.scrollHome.getBoundingClientRect().top
			this.aboutTop = this.$refs.scrollAbout.getBoundingClientRect().top
			this.projectTop = this.$refs.scrollProject.getBoundingClientRect().top
			this.contactTop = this.$refs.scrollContact.getBoundingClientRect().top
			this.footerTop = this.$refs.scrollFooter.getBoundingClientRect().top

			// console.log("this.windowHeight: ",this.windowHeight);
			// console.log("this.footerTop: ",this.footerTop);

			// console.log("111111111------------111111: ",this.windowHeight-this.footerTop);
			// console.log("11: ",this.$refs.scrollFooter.getBoundingClientRect());
			// 是否固定底部 
			if (this.windowWidth < 480) {
				// if (this.footerTop < 630) {
				if (this.windowHeight - this.footerTop > 60) {
					this.isFixed = false
				} else {
					this.isFixed = true
				}
			} else {
				this.isFixed = false
			}

			// console.log("this.aboutTop: ",this.aboutTop);
			// console.log("this.projectTop: ",this.projectTop);
			// console.log("this.contactTop: ",this.contactTop);
			if (this.homeTop <= 0 && this.aboutTop > 0) {
				this.navIndex = 0
				document.title = this.$t('nav.home')
			} else if (this.aboutTop <= 0 && this.projectTop > 1) {
				this.navIndex = 1
				document.title = this.$t('nav.about')
			} else if (this.projectTop <= 1 && this.contactTop > 1) {
				this.navIndex = 2
				document.title = this.$t('nav.project')
			} else if (this.contactTop <= 1) {
				this.navIndex = 3
				document.title = this.$t('nav.contact')
			}
		},
	}
}
</script>

<style>

</style>
